export class Editable {
    constructor(element) {
        this.element = element;
        this.editLink = element.data("edit-link");
        this.deleteLink = element.data("delete-link");

        this.baseElementTemplate = `
            <div class="element-editor">
                <div class="element-editor-container">
                </div>
            </div>`;

        this.editButtonTemplate = `
            <span class="element-editor-button edit">
                <i class="icon edit-icon"></i>
                <button>Изменить элемент</button>
            </span>`;

        this.deleteButtonTemplate = `
            <span class="element-editor-button delete">
                <i class="icon delete-icon"></i>
                <button>Удалить элемент</button>
            </span>`;
    }

    enable() {
        this.createBaseElement();

        if (this.deleteLink) {
            this.createDeleteElement();
        }

        if (this.editLink) {
            this.createEditElement();
        }
    }

    createBaseElement() {
        this.element.prepend(this.baseElementTemplate);
    }

    createEditElement() {
        const container = this.element.find(".element-editor-container");
        const link = this.editLink;
        const callback = function() {
            /* eslint-disable */
            (new BX.CAdminDialog({'content_url': link})).Show();
            /* eslint-enable */
            return false;
        };
        this.element.dblclick(function() {
            callback();
        });
        container.prepend(this.editButtonTemplate);
        container.find(".edit").click(function() {
            callback();
        });
    }

    createDeleteElement() {
        const container = this.element.find(".element-editor-container");
        const link = this.deleteLink;
        const callback = function() {
            if (confirm("Вы уверены, что хотите удалить эту запись?")) {
                window.location.href = link;
            }
        };
        container.prepend(this.deleteButtonTemplate);
        container.find(".delete").click(function() {
            callback();
        });
    }
}
